import { ErrorMessage, Field } from "formik";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { useLocation } from "react-router-dom";
import { useState } from "react";
const ProjectSection = () => {
  const location = useLocation();
  const currentPathname = location.pathname;
  const [show, setShow] = useState(false);
  return (
    <Row>
      <Col sm="6">
        <FormGroup>
          <Label check>Username</Label>
          <Field
            name="username"
            className="form-control"
            type="text"
            placeholder={"username"}
          />
          <ErrorMessage
            name="username"
            component="span"
            className="text-danger"
          />
        </FormGroup>
      </Col>
      <Col sm="6">
        <FormGroup>
          <Label className="col-form-label">
            {currentPathname.includes("/users/edit")
              ? "New Password"
              : "Password"}
          </Label>
          <div className="form-input position-relative">
            <Field
              type={show ? "text" : "password"}
              placeholder="*********"
              className="form-control"
              name="password"
            />
            <div
              className="show-hide"
              style={{ top: "50%", transform: "translateY(-50%)" }}
              onClick={() => setShow(!show)}
            >
              <span className="show"> </span>
            </div>
          </div>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default ProjectSection;
